<template>
  <main id="subPage">
    <!-- 카테고리 -->
    <section id="category">
      <h2>주차서비스</h2>
      <ul class="breadCrumb">
        <li class="home"></li>
        <li class="web">
          <p class="pageTxt">주차서비스</p>
          <ul class="depth">
            <li><router-link to="/map" title="공영주차장">공영주차장</router-link></li>
            <li><router-link to="/prepaymentinfo" title="주차요금정산">주차요금정산</router-link></li>
            <li><router-link to="/periodinfo" title="주차서비스">주차서비스</router-link></li>
            <li><router-link to="/noticelist" title="정보마당">정보마당</router-link></li>
          </ul>
        </li>
        <li class="web">
          <p class="pageTxt">정기권</p>
          <ul class="depth">
            <li><router-link to="/periodinfo" title="정기권">정기권</router-link></li>
            <li><router-link to="/webdiscountcharge" title="웹 선불권">웹 선불권</router-link></li>
          </ul>
        </li>
        <li>
          <p class="pageTxt">정기권 안내</p>
          <ul class="depth">
            <li><router-link to="/periodinfo" title="정기권 안내">정기권 안내</router-link></li>
            <li><router-link to="/periodapplication" title="정기권 신청">정기권 신청</router-link></li>
            <!-- <li><router-link to="/periodlookup" title="정기권 조회/결제">정기권 조회/결제</router-link></li> -->
          </ul>
        </li>
      </ul>
    </section>

    <!-- 컨텐츠 영역 -->
    <section id="content">
      <div class="inner">
        <h3 class="pageTitle">정기권 안내</h3>
        <article>
          <p class="subTitle">정기권 온라인 신청 절차</p>
          <!--periodStep-->
          <div class="periodStep web">
            <ul>
              <li class="step01">인터넷 정기권<br />발매 공고</li>
              <li class="step02">로그인</li>
              <li class="step03">정기권 신청</li>
              <li class="step04">증명서 제출<br />(대상자에 한함)</li>
              <li class="step05">대상자 확인</li>
              <li class="step06">결제</li>
            </ul>
          </div>
          <div class="periodStep mobile">
            <ul>
              <li class="step01">인터넷 정기권<br />발매 공고</li>
              <li class="step02">로그인</li>
              <li class="step03">정기권 신청</li>
              <li class="step04">결제</li>
              <li class="step05">대상자 확인</li>
              <li class="step06">증명서 제출<br />(대상자에 한함)</li>
            </ul>
          </div>
          <!--//periodStep-->
          <div class="infoBox">
            <ul class="bullet arrowType">
              <li>정기권은 선착순을 통한 판매가 기본이며, 3개월 단위로 최대 6개월까지 신청이 가능합니다.</li>
              <li>주차장 상황에 따라 만차가 될 경우 월정기권 구매 시민이라 하더라도 주차가 불가한 점 유의하시기 바랍니다.</li>
              <li>오프라인 신청 시 신청서 접수일을 기준으로 접수됩니다.</li>
            </ul>
          </div>
        </article>
        <article>
          <p class="subTitle">이용요금</p>
          <div class="table blue-table">
            <table>
              <caption>
                노상주차장 정기권 요금 안내 테이블
              </caption>
              <colgroup>
                <col style="width: 20%" />
                <col style="width: 20%" />
                <col style="width: 20%" />
                <col style="width: 20%" />
                <col style="width: 20%" />
              </colgroup>
              <thead>
                <tr>
                  <th scope="col">대상주차장</th>
                  <th scope="col">급지</th>
                  <th scope="col">주간<br /><span>(08:00 ~ 20:00)</span></th>
                  <th scope="col">야간<br /><span>(18:30 ~ 익일08:00)</span></th>
                  <th scope="col">주야간(전일)<br /><span>(08:00 ~ 익일8:00)</span></th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th scope="row">공설운동장, 북샛말, 서희청소년문화센터</th>
                  <td>2급지</td>
                  <td><span class="f15">50,000원</span></td>
                  <td><span class="f15">30,000원</span></td>
                  <td><span class="f15">60,000원</span></td>
                </tr>
                <tr>
                  <th scope="row">택시쉼터</th>
                  <td>3급지</td>
                  <td><span class="f15">30,000원</span></td>
                  <td><span class="f15">20,000원</span></td>
                  <td><span class="f15">40,000원</span></td>
                </tr>
              </tbody>
            </table>
          </div>
        </article>
        <article>
          <p class="subTitle">월정기권 운영 현황</p>
          <div class="scroll-table">
            <i class="v-scroll"></i>
            <div class="table month-table">
              <table>
                <caption>
                  월정기권 운영 현황
                </caption>
                <colgroup>
                  <col style="width: 20%" />
                  <col style="width: 25%" />
                  <col style="width: 15%" />
                  <col style="width: 15%" />
                  <col style="width: 15%" />
                </colgroup>

                <thead>
                  <tr>
                    <th scope="col">주차장</th>
                    <th scope="col">주소</th>
                    <th scope="col">주차면수</th>
                    <th scope="col">주간/야간</th>
                    <th scope="col">적용기간</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <th scope="row">북샛말 주차장</th>
                    <td>경기 이천시 이섭대천로 1299</td>
                    <td>176면</td>
                    <td>160대/160대</td>
                    <td rowspan="4">3개월 단위<br /><span>(최대 6개월)</span></td>
                  </tr>
                  <tr>
                    <th scope="row">서희청소년문화센터 주차장</th>
                    <td>경기 이천시 영창로 260</td>
                    <td>195면</td>
                    <td>180대/180대</td>
                  </tr>
                  <tr>
                    <th scope="row">택시쉼터 주차장</th>
                    <td>경기 이천시 창전동 417</td>
                    <td>230면</td>
                    <td>210대/210대</td>
                  </tr>
                  <tr>
                    <th scope="row">공설운동장 주차장</th>
                    <td>경기 이천시 서희로 11</td>
                    <td>464면</td>
                    <td>420대/420대</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <p class="info">운영시간 : 24시간 연중휴무</p>
          </div>
        </article>
        <article>
          <p class="subTitle">정기권 신청</p>
          <div class="infoArticle">
            <p class="tit">정기권 신청 이용안내</p>
            <ul class="bullet dotType">
              <li>
                월정기권 신청은 3개월 단위로 신청 가능하며, 최대 6개월까지 신청 가능합니다.
                <span>(월 기준은 매월 1일 0시~말일 24시)</span> <br />
                <span>(야간정기권 이용기간 : 매월 1일 18시30분~말일 익일 8시까지 적용)</span>
              </li>
              <li>
                월정기권 요금은 총액 선불로 운영됩니다.
                <span class="colorType purple">(월 납부시 만료일 7일전 미납 시 자동해지)</span> <br />
                <span>(대기자 발생 시 월 단위 연장 결제 불가하며, 월정기권 만료 시 신규로 신청)</span>
              </li>
              <li>월정기권 계약 해지 요청 시 월정기권 요금 요청일로부터 일할 계산 후 반환됩니다.</li>
              <!-- <li>
                월정기권 이용 대상 차량변경은 공영주차장 사무실에서 변경이 가능합니다.(신청서 작성)
                <p class="colorType gray">변경 대상 차량이 월정기권 이용 마감 후 6개월 이내 차량일 경우 변경 불가</p>
              </li> -->
              <li>월정기권 별도 지정구역이 없으며, 주차 공간이 없을 경우 대기 후 사용합니다.</li>
              <li>월정기권 재신청은 이용기간 만료 이후 재신청이 가능(이용 중 신청 불가)</li>
              <li>월정기권 이용 시 신청서에서 신청된 주차장에 한하여 적용됨니다.</li>
              <li>월정기권 이용 차량은 신청시간외 주차시 주차료발생합니다.</li>
              <li>월정기권 운영 공영주차장은 월정기권 차량 및 일반 차량 통합 운영 시설입니다.</li>
              <li>운영 사정에 의한 무료 운영기간은 별도 환급되지 않습니다.</li>
            </ul>
          </div>
        </article>
        <article>
          <p class="subTitle">유의사항</p>
          <ul class="bullet dotType">
            <li>
              월정기권
              <span class="colorType purple">이용료는 신청서 접수 시 총액 선불 납부</span>합니다.(월 납부 시 이용
              <span class="colorType purple">만료일 7일전 입금</span>)
            </li>
            <li>
              월정기권 이용료
              <span class="colorType purple">납부기한 내까지 미납시 신청 해지</span> 후 신규 신청 가능합니다.
            </li>
            <li>
              <span class="colorType purple">장애인 주차장은 장애인 주차면 주차 가능 스티커 부착차량</span>만 주차
              가능합니다.
            </li>
            <li>
              월정기권 이용객은
              <span class="colorType purple">일반 차량 주차로 인하여 주차 공간이 없을 경우 대기 후 사용</span>이
              가능합니다.
            </li>
            <li>
              월정기권 차량은
              <span class="colorType purple">신청 공영주차장 외 타 주차장에 주차 할 경우 주차요금이 발생</span>합니다.
            </li>
            <li>
              월정기권 운영은
              <span class="colorType purple">기간만료 시 대기 접수 후 순차적으로</span> 등록됩니다.<br />
            </li>
          </ul>
        </article>
        <article class="btnArea">
          <button type="button" class="btn blue" @click="$router.push('/periodapplication')">정기권 신청</button>
        </article>
      </div>
    </section>
  </main>
</template>

<script>
import axios from 'axios';

export default {
  data() {
    return {};
  },

  components: {},

  mounted() {},

  methods: {},
};
</script>
